import { render, staticRenderFns } from "./BaseErrorAlert.vue?vue&type=template&id=0a0f9c58"
import script from "./BaseErrorAlert.vue?vue&type=script&lang=js"
export * from "./BaseErrorAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports